var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Error.module.scss';
import { Button, EButtonType } from 'src/ui/components/button/Button';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { Image } from 'src/ui/components/Image/Image';
import { useRouter } from 'src/shared/hooks/useRouting';
import { URL_PATH } from 'src/shared/constants';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { Icons } from 'src/ui/components/Icons/Icons';
export var Error = function (props) {
    var i18n = props.i18n, token = props.token;
    var router = useRouter();
    var basePath = window.env.BASE_PATH;
    var handleOnClick = function () {
        router.push(URL_PATH.CASES);
    };
    var description = getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.errorPage.description').replace('$token', token);
    var buttonLabel = getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.errorPage.button');
    var handleTextCopy = function (e) {
        e.stopPropagation();
        navigator.clipboard.writeText(token);
    };
    return (_jsxs("div", __assign({ className: styles.caseDetailErrorWrapper }, { children: [_jsx(Image, { src: "".concat(basePath, "/images/fourOhFour.svg") }), _jsxs("div", __assign({ className: styles.caseDetailErrorDescriptionWrapper }, { children: [_jsx("p", __assign({ className: styles.caseDetailErrorDescription }, { children: description })), _jsx(Icons, { icon: E_ICONS.COPY, className: styles.caseDetailErrorCopyIcon, onClick: handleTextCopy })] })), _jsx(Button, { type: EButtonType.NEUTRAL, isEdge: true, leftIcon: E_ICONS.ARROW_LEFT, label: buttonLabel, onClick: handleOnClick })] })));
};
